export class Doctor {
  id: number = 0;
  full_name: string = '';
  avatar: string | null = null;
  constructor(data: Partial<Doctor>) {
    Object.assign(this, data);
  }
}
